import store from "@/store";
import axios from "axios";
import constants from "@/config/config.js";
// import toast from "@/utils/toast";
const _axios = axios.create();
const makeRequestCreator = () => {
  let call;
  return (url, method, data = null) => {
    call = axios.CancelToken.source();
    const headers = {};
    if (store && store.getters && store.getters.token)
      headers.token = store.getters.token;
    const options = {
      headers,
      url: `${constants.apiEndPoint}api/${url}`,
      method,
      data,
      cancelToken: call.token
    };
    return {
      call,
      axios: _axios
        .request(options)
        .then(response => {
          return response;
        })
        .catch(response => {
          return response;
        })
    };
  };
};
let request = makeRequestCreator();

class Api {
  constructor(instance) {
    this.instance = instance;
    this.interceptors();
    this.activeRequests = [];
  }
  addActiveRequest(request) {
    const route = constants.apiEndPoint + request.route.split("?")[0];
    this.activeRequests.push({ route, call: request.call });
  }
  removeActiveRequest(route) {
    route = route.split("?")[0];
    this.activeRequests = this.activeRequests.filter(ar => ar.route != route);
  }
  abortRequest(route) {
    route = route.split("?")[0];
    route = constants.apiEndPoint + route;
    const toAbort = this.activeRequests.filter(ar => ar.route == route)[0];
    if (toAbort) {
      this.removeActiveRequest(route);
      toAbort.call.cancel({ abort: true, route });
    }
  }
  interceptors() {
    _axios.interceptors.response.use(
      response => {
        this.removeActiveRequest(response.config.url);
        const { data, headers } = response;
        const oData = (data && data.data) || data;
        return { headers, status: true, data: oData, error: null };
      },
      oError => {
        // console.log("oError", oError.message);
        const { response, message } = oError || {};
        let { status, data } = response || {};
        const aDigitStatus = status && Math.trunc(status / 100);
        if (data.data) data = data.data || {};
        const error = (data && (data.text || data.error)) || message;
        const status_code = (data && data.status_code) || status;
        if (aDigitStatus === 4 && !error) {
          alert(error);
          // toast("alert", error, 5000);
        }
        if (aDigitStatus === 5) {
          alert(`${error}<br>CODE: ${status_code}`);
          // toast("error", `${error}<br>CODE: ${status_code}`, 0);
        }
        let api_response = {
          status: false,
          data: [],
          error,
          aborted: error.abort ? true : false
        };
        if (error === "Network Error") {
          alert(error);
          // toast("error", error, 5000);
          api_response.error = "";
        }
        return Promise.reject(api_response);
      }
    );
  }

  get(route, data, blockMultiple) {
    // ?test abort
    if (typeof data == "boolean") blockMultiple = data;
    if (!blockMultiple) this.abortRequest(route);
    const getRequest = this.instance(route, "GET", data, blockMultiple);
    this.addActiveRequest({ route, call: getRequest.call });
    return getRequest.axios;
  }

  post(route, params, blockMultiple) {
    const getRequest = this.instance(route, "POST", params, blockMultiple);
    return getRequest.axios;
  }

  put(route, params, blockMultiple) {
    const getRequest = this.instance(route, "PUT", params, blockMultiple);
    return getRequest.axios;
  }

  delete(route, params = null, blockMultiple) {
    const getRequest = this.instance(route, "DELETE", params, blockMultiple);
    return getRequest.axios;
  }

  addHeader(Headers) {
    this.instance.defaults.headers = { ...Headers };
    return this;
  }
}

const api = new Api(request);
export default api;
